import {
  BuildOutlined,
  DatabaseOutlined,
  FileTextOutlined,
  FundOutlined,
  HomeOutlined,
  LayoutOutlined,
  MessageOutlined,
  PlayCircleOutlined,
  ProjectOutlined,
} from '@ant-design/icons';
import { PermissionAction, PermissionAsset } from '@redux/types/types';
import { UserRoles } from './enum/common';

export interface ISidebarMenuItem {
  label: string;
  link?: string;
  icon?: any;
  userAccess?: UserRoles[]; // TODO(RBCA): Remove this once we switched to permissions
  submenu?: ISidebarMenuItem[];
  newLabel?: boolean;
  betaLabel?: boolean;
  permissions?: Partial<Record<PermissionAsset, PermissionAction>>;
}

export type ISidebarMenuSettings = ISidebarMenuItem[];

export const SIDEBAR_MENU_ITEMS: ISidebarMenuSettings = [
  {
    label: 'Home',
    link: '/',
    icon: HomeOutlined,
    userAccess: [UserRoles.ADMIN, UserRoles.EDITOR],
  },
  {
    label: 'Data',
    userAccess: [UserRoles.ADMIN],
  },
  {
    label: 'Files',
    link: '/files',
    icon: FileTextOutlined,
    userAccess: [UserRoles.ADMIN, UserRoles.EDITOR],
    permissions: {
      [PermissionAsset.FILES]: PermissionAction.READ,
    },
  },
  {
    label: 'Indexes',
    link: '/indexes',
    icon: DatabaseOutlined,
    userAccess: [UserRoles.ADMIN, UserRoles.EDITOR],
    permissions: {
      [PermissionAsset.INDEXES]: PermissionAction.READ,
      [PermissionAsset.PIPELINES]: PermissionAction.READ,
    },
  },
  {
    label: 'Configuration',
    userAccess: [UserRoles.ADMIN],
  },
  {
    label: 'Pipeline Templates',
    link: '/pipelines/templates',
    icon: LayoutOutlined,
    userAccess: [UserRoles.ADMIN, UserRoles.EDITOR],
    permissions: {
      [PermissionAsset.PIPELINES]: PermissionAction.READ,
    },
  },
  {
    label: 'Pipelines',
    link: '/pipelines',
    icon: ProjectOutlined,
    userAccess: [UserRoles.ADMIN, UserRoles.EDITOR],
    permissions: {
      [PermissionAsset.PIPELINES]: PermissionAction.READ,
    },
  },
  {
    label: 'Jobs',
    link: '/jobs',
    icon: BuildOutlined,
    userAccess: [UserRoles.ADMIN, UserRoles.EDITOR, UserRoles.SEARCH_USER],
    permissions: {
      [PermissionAsset.JOBS]: PermissionAction.READ,
    },
  },
  {
    label: 'Testing',
    userAccess: [UserRoles.ADMIN],
  },
  {
    label: 'Playground',
    link: '/playground',
    icon: PlayCircleOutlined,
    userAccess: [UserRoles.ADMIN, UserRoles.SEARCH_USER, UserRoles.EDITOR],
    permissions: {
      [PermissionAsset.PIPELINES]: PermissionAction.READ,
    },
  },
  {
    label: 'Prompt Explorer',
    link: '/prompt-explorer',
    icon: MessageOutlined,
    userAccess: [UserRoles.ADMIN, UserRoles.EDITOR],
    permissions: {
      [PermissionAsset.PIPELINES]: PermissionAction.READ,
      [PermissionAsset.PROMPTS]: PermissionAction.READ,
    },
  },
  {
    label: 'Monitoring',
    userAccess: [UserRoles.ADMIN],
  },
  {
    label: 'Groundedness',
    link: '/groundedness',
    icon: FundOutlined,
    userAccess: [UserRoles.ADMIN, UserRoles.EDITOR],
    permissions: {
      [PermissionAsset.PIPELINES]: PermissionAction.READ,
    },
  },
];

export const WORKSPACE_INPUT_PLACEHOLDER = 'Workspace name';
export const WORKSPACE_CREATE_BUTTON_LABEL = 'Create';
